// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.b1_kBS {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.ezJyJx {
  background: white;
  border-radius: 8px;
  padding: 24px;
  max-width: 480px;
  width: 90%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.OPkzgU {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.OEFfa6 {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  color: #333;
}

.MG2DsQ {
  padding: 4px;
  background: transparent;
  border: none;
  cursor: pointer;
}

.MRUkz2 {
  margin-bottom: 24px;
}

.nfm5IQ {
  font-size: 14px;
  line-height: 1.5;
  color: #666;
  margin: 0 0 20px;
}

.r2eJIx {
  margin-top: 4px;
}

.tKg2G1 {
  display: flex;
  gap: 12px;
  width: 100%;
}

.fe1q7h,
.rEIFho {
  flex: 1;
}

.qjJ3s0 {
  margin-right: 8px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/CancelOrderModal/CancelOrderModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA;;EAEE,OAAO;AACT;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal {\n  background: white;\n  border-radius: 8px;\n  padding: 24px;\n  max-width: 480px;\n  width: 90%;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.title {\n  font-size: 20px;\n  font-weight: 600;\n  margin: 0;\n  color: #333;\n}\n\n.closeButton {\n  padding: 4px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n}\n\n.content {\n  margin-bottom: 24px;\n}\n\n.warning {\n  font-size: 14px;\n  line-height: 1.5;\n  color: #666;\n  margin: 0 0 20px;\n}\n\n.checkboxRow {\n  margin-top: 4px;\n}\n\n.actions {\n  display: flex;\n  gap: 12px;\n  width: 100%;\n}\n\n.cancelButton,\n.confirmButton {\n  flex: 1;\n}\n\n.loadingSpinner {\n  margin-right: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backdrop": `b1_kBS`,
	"modal": `ezJyJx`,
	"header": `OPkzgU`,
	"title": `OEFfa6`,
	"closeButton": `MG2DsQ`,
	"content": `MRUkz2`,
	"warning": `nfm5IQ`,
	"checkboxRow": `r2eJIx`,
	"actions": `tKg2G1`,
	"cancelButton": `fe1q7h`,
	"confirmButton": `rEIFho`,
	"loadingSpinner": `qjJ3s0`
};
module.exports = ___CSS_LOADER_EXPORT___;
